<template>
  <v-row class="pt-1" align="center">
    <v-col align-self="center" class="shrink">
      <span class="material-symbols-outlined pt-1" style="color: grey"> communities </span>
    </v-col>
    <v-col class="pr-0">
      <vs-autocomplete
        :items="props.selectableServiceProviders"
        :value="props.stage.recipients"
        item-text="name"
        item-value="id"
        :label="label"
        multiselect
        :rules="[(items) => items?.length === 0 && 'One or more service providers are required']"
        @input="updateServiceProviders"
      >
        <template #prepend-item>
          <v-list-item ripple data-test="select-all-option" @click="handleSelectAllButton">
            <v-list-item-action>
              <v-icon :color="'indigo darken-4'">{{ selectAllIcon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <vs-text>{{ selectAllLabel }}</vs-text>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
        </template>
      </vs-autocomplete>
    </v-col>
    <v-col align-self="center" class="shrink pl-1">
      <vs-button
        data-test="remove-stage"
        icon="clear"
        small
        destructive
        type="tertiary"
        @click="removeStage"
      />
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import VsAutocomplete from '@/components/vision/Inputs/VsAutocomplete/VsAutocomplete.vue'
import { computed } from 'vue'
import { EligibleServiceProvider } from '../../api/pools'
import { AdHocPoolStage } from './AdHocPoolCreator.vue'
import { addOrdinalIndicator } from '@/utils/number-formatting'

const emits = defineEmits<{
  (e: 'update-stage', adHocPoolStage: AdHocPoolStage)
  (e: 'remove-stage', stageNumber: number)
}>()

const props = defineProps<{
  stage: AdHocPoolStage
  selectableServiceProviders: EligibleServiceProvider[]
}>()

const updateServiceProviders = (value) => {
  emits('update-stage', {
    stageNumber: props.stage.stageNumber,
    recipients: value,
  })
}
const handleSelectAllButton = () => {
  let recipients: string[] = []

  if (props.stage.recipients.length < props.selectableServiceProviders.length) {
    recipients = props.selectableServiceProviders.map((r) => r.id)
  }

  emits('update-stage', {
    stageNumber: props.stage.stageNumber,
    recipients,
  })
}

const removeStage = () => {
  emits('remove-stage', props.stage.stageNumber)
}

const selectAllIcon = computed(() => {
  return props.stage.recipients.length < props.selectableServiceProviders.length
    ? 'mdi-plus-box'
    : 'mdi-minus-box'
})
const selectAllLabel = computed(() => {
  return props.stage.recipients.length < props.selectableServiceProviders.length
    ? 'Select All'
    : 'Deselect All'
})

const label = computed<string>(() => {
  const ordinalNumber = addOrdinalIndicator(props.stage.stageNumber)
  return `Notify ${ordinalNumber}`
})
</script>
